import React, { useState, useEffect } from "react";
import axios from "../../utils/axios";
import Select from "react-select";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import { HiOutlineTrash, HiPlus,HiOutlineCash } from "react-icons/hi";
import { toast } from "react-toastify";

const RateImage = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [roomList, setRoomList] = useState([]);
  const [rateImageList, setRateImageList] = useState([]);

  const [newRateImage, setNewRateImage] = useState({
    HOTEL_ID: hotel_id,
    SALES_ID: "",
    LINK_RATE_IMG: "",
    NO_URUT_IMG: "",
  });

  // Add this line to define previewImage and its setter
  const [previewImage, setPreviewImage] = useState(null);
  const [isAddModalOpen, setAddModalOpen] = useState(false);

  // Fetch property details
  const getDetailProperty = async (hid) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hid}`);
      if (response.status === 200) setPropData(response.data);
    } catch (err) {
      console.error("Error fetching property details:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch room list
  const getRoomSelect = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/rooms/sale/${hotel_id}`);
      if (response.status === 200) {
        setRoomList(response.data.data); 
        console.log('Response room list : ',response.data.data);
      } else {
        throw new Error("Failed to fetch room sales data");
      }
    } catch (err) {
      console.error("Error fetching room list:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch room images
  const getImageRateList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/rate/images/${hotel_id}`);
      console.log(response.data)
      setRateImageList(response.data)
      
    } catch (err) {
      console.error("Error fetching image list:", err);
    } finally {
      setLoading(false);
    }
  };

  const openModalAddNewImgRate = (rate) => {
    // console.log(rate.sale_id)
    setNewRateImage({ ...newRateImage, SALES_ID: rate.sale_id })
    setPropData(rate)
    setAddModalOpen(true)
  }

  // Add new image
  const handleAddImage = async (e) => {
    e.preventDefault();
  
    try {
      const formData = new FormData();
      formData.append("UID", userData.id);
      formData.append("HOTEL_ID", hotel_id);
      formData.append("SALES_ID", newRateImage.SALES_ID);
      formData.append("LINK_RATE_IMG", newRateImage.LINK_RATE_IMG); // Append the file
      formData.append("NO_URUT_IMG", newRateImage.NO_URUT_IMG);
      
      const response = await axios.post(`/api/insert/rate/image`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      if (response.status === 200) {
        toast.success(response.data.message);
        await getImageRateList();
        setNewRateImage({ HOTEL_ID: "", SALES_ID: "", LINK_RATE_IMG: "" ,NO_URUT_IMG:""});
        setPreviewImage(null);
        setAddModalOpen(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.error("Error adding image:", err);
      toast.error("An error occurred while adding the image.");
    }
  };
  
  // Delete image
  const handleDeleteImage = async (imageId) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      try {
        const response = await axios.get(`/api/delete/room/rate/image/${imageId}`);
        if (response.status === 200) {
          toast.success("Image deleted successfully.");
          await getImageRateList(hotel_id);
        } else {
          toast.error("Failed to delete image.");
        }
      } catch (err) {
        console.error("Error deleting image:", err);
        toast.error("An error occurred while deleting the image.");
      }
    }
  };

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      getRoomSelect();
      getImageRateList();
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, []);

  return (
    <div className="flex h-screen bg-gray-200">
      <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={propData.ID_HOTEL || "Loading..."}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar 
          setMiniSidebar={setMiniSidebar} 
          isMiniSidebar={isMiniSidebar} 
        />
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          <div className="mb-4 text-xs font-semibold text-[#101827]">
            <span>Ashley Hotel Group</span> &gt; <span>Rate Room Gallery</span> &gt; <span>{propData.NAME_HOTEL}</span>
          </div>

          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
            {isLoading ? (
              <p>Loading...</p>
            ) : rateImageList?.length === 0 ? (
              <p className="text-center text-sm text-gray-500">No Record. Please upload a first rate image.</p>
            ) : (
              rateImageList?.map((rate, index) => (
                <div key={index} className="mb-4 border p-4 bg-slate-100 rounded-md">
                  
                  <div className="flex justify-between items-center mb-2">
                    <h2 className="text-sm md:text-base font-semibold text-[#101827]">
                      {rate.room_name} ({rate.rate_code})
                    </h2>
                    <button className="bg-[#111c30] text-sm text-white py-2 px-4 rounded-md flex items-center space-x-2" 
                      onClick={() => openModalAddNewImgRate(rate)}
                    >
                      <HiOutlineCash />
                      <span> More</span>
                    </button>
                  </div>

                  {/* Image Gallery */}
                  {rate.images?.length === 0 ? ( // Use optional chaining and check if images array is empty
                    <p className="text-center text-gray-500">No Record. Please upload a rate image first.</p>
                  ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-5 gap-4">
                      {rate.images?.map((image, index) => ( // Optional chaining to check if images exist
                        <div key={index} className="relative group overflow-hidden">
                          {/* Image */}
                          <img
                            src={image.LINK_RATE_IMG}
                            alt={`Rate ${rate.room_name}`}
                            className="w-full h-52 object-cover rounded-lg shadow-md transform transition-transform duration-300 group-hover:scale-110"
                          />

                          {/* NO_URUT Label */}
                          <span
                            className="absolute top-2 left-2 bg-blue-600 text-white text-xs font-semibold px-2 py-1 rounded-full shadow-md"
                            title={`Order: ${image.NO_URUT_IMG}`}
                          >
                            {image.NO_URUT_IMG}
                          </span>

                          {/* Delete Button */}
                          <button
                            className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition"
                            onClick={() => handleDeleteImage(image.ID_RATE_IMG)}
                          >
                            <HiOutlineTrash size={20} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </section>


        </main>
      </div>

      <button
        className="fixed bottom-10 right-10 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-500 transition"
        onClick={() => setAddModalOpen(true)}
        title="Add Image"
      >
        <HiPlus size={24} />
      </button>

      {isAddModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 shadow">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
            <h2 className="text-base font-semibold mb-4">New Rate Image {propData.room_name}</h2>
            <form onSubmit={handleAddImage}>

              {/* Room Select Dropdown */}
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Select Room</label>
                <select
                  value={newRateImage.SALES_ID}
                  onChange={(e) => setNewRateImage({ ...newRateImage, SALES_ID: e.target.value })}
                  className="w-full text-xs border rounded px-3 py-2"
                  required
                >
                  <option value="" disabled>Select a room</option>
                  {isLoading ? (
                    <option>Loading rooms...</option>
                  ) : (
                    roomList.map((room,index) => (
                      <option key={index} value={room.ID_ROOM_SALE}>
                        {room.ROOM_NAME} - {room.NAME_RATE} - {room.RATE_CODE}
                      </option>
                    ))
                  )}
                </select>
              </div>
             
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Upload Image</label>
                {/* File Input */}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setNewRateImage({
                        ...newRateImage,
                        LINK_RATE_IMG: file, // Store the file itself
                      });
                      setPreviewImage(URL.createObjectURL(file)); // Generate preview URL
                    }
                  }}
                  className="w-full border rounded px-3 text-xs py-2"
                  required
                />
              </div>
              {/* Image Preview */}
              {previewImage && (
                <div className="mb-4">
                  <label className="block text-xs font-medium mb-1">Image Preview</label>
                  <img
                    src={previewImage}
                    alt="Preview"
                    className="w-full h-40 object-cover rounded-md border text-xs"
                  />
                </div>
              )}
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Order Number</label>
                <input
                  type="number"
                  value={newRateImage.NO_URUT_IMG}
                  onChange={(e) => setNewRateImage({ ...newRateImage, NO_URUT_IMG: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  className="bg-gray-300 px-4 py-2 rounded mr-2"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded text-white"
                >
                  Add Image
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default RateImage;
